import { PRODUCT_LISTING } from './actionType'

export const productListing = (data) => {
  return {
    type: PRODUCT_LISTING,
    payload: data,
  }
}
